module.exports = __webpack_public_path__ + "static/media/HCMM666.5a9b049d.jpg";